import styled from "styled-components";
import bannerBg from "../../../../assets/images/nft/v2_banner_bG.png";
import sectionBgVideo from "../../../../assets/images/banner/alpha_octopus_video.mp4";
import logo from "../../../../assets/images/logo/logo.png";
import banner from "../../../../assets/images/octopuses/bg-1.jpg";

const BannerStyleWrapper = styled.section`
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  padding: 192px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .bithu_v2_baner_content {
    margin-top: 35px;
    position: relative;
    display:flex;
    flex-direction:column;
    .banner-emot {
      display: block;
      text-align: center;
      margin-bottom: 20px;
    }
    h2 {
      font-family: "Bakbak One";
      font-style: normal;
      font-weight: 400;
      font-size: 60px;
      line-height: 1.2;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      margin-bottom: 6%;
      position: relative;
      z-index: 2;
      span {
        color: #ff004c;
      }
    }
    h3 {
      font-size: 40px;
      line-height: 65px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      position: relative;
      margin: 0;
      z-index: 2;
    }

    span {
      display: inline-block;
    }

    .bithu_v2_timer {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 15px;
      z-index: 2;
      h4 {
        font-size: 68px;
        line-height: 65px;
        text-align: center;
        text-transform: uppercase;
        color: #ffffff;
        margin: 0;
      }
    }

    /* timer  */
    .root-react-component-countdown-timer {
      line-height: 65px;
      text-align: center;
      text-transform: uppercase;
      margin-bottom: 5rem;
      color: #ffffff;
      .countBox {
        font-family: "Bakbak One";
        font-size: 10rem !important;
        display: flex;
        flex-direction: row-reverse;
        column-gap: 10px;

        .split{
          color: rgba(255, 255, 255, 0.2);
        }
      }
    }

    .bithu_v2_baner_buttons {
      margin-top: 41px;
      button {
        margin: 0 auto;
      }
    }
    video{
      display: none;
    }
    .v2_baner_stars {
      top: -80px;
      height: 499px;
    }
  }

  @media only screen and (max-width: 991px) {
    padding-bottom: 80px;
    background: url(${banner});
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .bgVideo{
      display: none;
    }
    .container{
      background-color: rgba(0, 0, 0, 0.8);
    }
    .bithu_v2_baner_content {
      h2 {
        font-size: 50px;
      }

      h3 {
        font-size: 35px;
      }
     
      .bithu_v2_timer {
        h4 {
          font-size: 35px;
        }
      }
    }
  }

  @media only screen and (max-width: 575px) {
    background: url(${banner});
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .bgVideo,.logo{
      display: none;
    }
    .container{
      background-color: rgba(0, 0, 0, 0.8);
    }
    .bithu_v2_baner_content {
      h2 {
        font-size: 30px;
        margin-bottom: 20px;
      }
      h3 {
        font-size: 21px;
      }

      .bithu_v2_timer {
        h4 {
          font-size: 21px;
        }
      }
    }

    .root-react-component-countdown-timer {
      .countBox {
        font-size: 40px !important;
      }
    }
  }
`;

export default BannerStyleWrapper;
